import React, { useState } from 'react';
import axios from '../../plugins/axios';

// components
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';
import alert from '../../helpers/alert';

const defaultGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' };

const AddServiceForm = ({ onSuccess, defaultCityId, grid }) => {
  const [succes, setSucces] = useState({});
  const [loading, setLoading] = useState(false);
  const [service, setService] = useState([
    { type: 'input', value: undefined, label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ', name: 'title', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÑÐ»ÑÐ³Ð¸' },
    { type: 'input', label: 'Ð¦ÐµÐ½Ð°, KZT', name: 'price', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ', inputType: 'number' },
    {
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾Ð± ÑÑÐ»ÑÐ³Ðµ',
      name: 'comment',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¾Ð± ÑÑÐ»ÑÐ³Ðµ',
    },
    {
      type: 'selectCity',
      label: 'ÐÐ¾ÑÐ¾Ð´',
      name: 'cityId',
      value: defaultCityId,
    },
  ]);

  const addService = () => {
    setLoading(true);
    let object = new Object();
    service.map((item) => {
      object[item.name] = item.value;
    });
    axios
      .post('/api/crm/additional-services/addAdditionalService', { additionalService: object, comment: object.comment })
      .then((res) => {
        setSucces({ message: 'Ð£ÑÐ»ÑÐ³Ð° Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°' });
        onSuccess && onSuccess(res?.data);
      })
      .catch((error) => {
        alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response));
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <Form
        handlerSetState={setService}
        inputs={service}
        title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾Ð± ÑÑÐ»ÑÐ³Ðµ'}
        grid={grid || defaultGrid}
        border
      />
      <Button onClick={() => addService()} text={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'} fill disabled={loading} />
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default AddServiceForm;
